'use client'

import { useEffect } from 'react'

// Hack: TinyMCE's link-plugin fields become uneditable inside a modal.
// Fix from https://stackoverflow.com/a/78385086

const fix = (event: FocusEvent) => {
  if (
    event.target instanceof HTMLElement &&
    event.target.closest(
      '.tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root'
    ) !== null
  ) {
    event.stopImmediatePropagation()
  }
}

export function FixTinyMCELinkPlugin() {
  useEffect(() => {
    document.addEventListener('focusin', fix)
    return () => {
      document.removeEventListener('focusin', fix)
    }
  }, [])

  return null
}
